import type { ComponentChildren } from "preact";
import { useT } from "../i18n";

export function Page({ title, sub, children, actions }: { title: string; sub?: string; children: ComponentChildren; actions?: ComponentChildren }) {
  return (
    <div class="page">
      <div class="page-h"><div><h1>{title}</h1>{sub && <div class="sub">{sub}</div>}</div>{actions}</div>
      {children}
    </div>
  );
}

export function State({ loading, error, empty, emptyText }: { loading: boolean; error?: string; empty?: boolean; emptyText?: string }) {
  const t = useT();
  if (loading) return <p style="color:var(--muted)">{t("x.loading")}</p>;
  if (error) return <p class="st st-crit">{t("x.error", { m: error })}</p>;
  if (empty) return <p style="color:var(--muted)">{emptyText}</p>;
  return null;
}
